var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/CommonVideoPlayer/CommonVideoPlayer.jinja"] = require( "front/components/CommonVideoPlayer/CommonVideoPlayer.jinja" );
dependencies["front/components/CommonVideoGallery/CommonVideoGallery.jinja"] = require( "front/components/CommonVideoGallery/CommonVideoGallery.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/MediaPopup/MediaPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/MediaPopup/MediaPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/MediaPopup/MediaPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/CommonVideoPlayer/CommonVideoPlayer.jinja", false, "assets/app/front/pages/MediaPopup/MediaPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "CommonVideoPlayer")) {
var t_10 = t_7.CommonVideoPlayer;
} else {
cb(new Error("cannot import 'CommonVideoPlayer'")); return;
}
context.setVariable("CommonVideoPlayer", t_10);
output += "\n";
env.getTemplate("front/components/CommonVideoGallery/CommonVideoGallery.jinja", false, "assets/app/front/pages/MediaPopup/MediaPopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "CommonVideoGallery")) {
var t_14 = t_11.CommonVideoGallery;
} else {
cb(new Error("cannot import 'CommonVideoGallery'")); return;
}
context.setVariable("CommonVideoGallery", t_14);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupClasses"))(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
output += t_17;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupClasses(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "BasePopup--black";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"MediaPopup\">\n        <div class=\"MediaPopup-back\">\n            <div class=\"MediaPopup-backArrow\">\n                ";
output += runtime.suppressValue((lineno = 12, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_20 = "";;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
return macro_t_19;})()})])), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"MediaPopup-backArrow MediaPopup-backArrow--mobile\">\n                ";
output += runtime.suppressValue((lineno = 15, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list-mobile","0 0 41 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_22 = "";;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
return macro_t_21;})()})])), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"MediaPopup-backLink\">\n                All videos\n            </div>\n        </div>\n        <div class=\"MediaPopup-content\">\n            <div class=\"MediaPopup-title-mobile\">\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title"), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"MediaPopup-video\" data-videos=\"";
output += runtime.suppressValue(env.getFilter("tojson").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"sources")), env.opts.autoescape);
output += "\">\n                ";
output += runtime.suppressValue((lineno = 26, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonVideoPlayer"), "CommonVideoPlayer", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"sources")),0),"delayed": 1})])), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"MediaPopup-infoWrapper\">\n                <div class=\"MediaPopup-info\">\n                    <div class=\"MediaPopup-title\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title"), env.opts.autoescape);
output += "\n                    </div>\n                    <div class=\"MediaPopup-credits\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"descriptionRendered")), env.opts.autoescape);
output += "\n                    </div>\n                    <div class=\"MediaPopup-infoShare\">\n                        <div class=\"MediaPopup-infoShare-title\">share</div>\n                        <div class=\"MediaPopup-infoShare-item MediaPopup-infoShare-item--facebook\">\n                            Facebook\n                        </div>\n                        <div class=\"MediaPopup-infoShare-item MediaPopup-infoShare-item--twitter\">\n                            Twitter\n                        </div>\n                        <div class=\"MediaPopup-infoShare-item MediaPopup-infoShare-item--mail\">\n                            Mail\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"sourcesCount") > 1) {
output += "\n                <div class=\"MediaPopup-slider\">\n                    <div class=\"MediaPopup-sliderInner\">\n                        ";
output += runtime.suppressValue((lineno = 54, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonVideoGallery"), "CommonVideoGallery", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "popup")})])), env.opts.autoescape);
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupClasses: b_popupClasses,
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/MediaPopup/MediaPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MediaPopup/MediaPopup.jinja
// module id = 549
// module chunks = 0